import { useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';

import { buildReferralShareMessage } from '../../../utils/referral';

const openShareWindow = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const copyText = async (value: string, successMessage: string) => {
  await navigator.clipboard.writeText(value);
  toast.success(successMessage);
};

const useReferralShare = (referralLink: string) => {
  const [message, setMessage] = useState('');

  const defaultMessage = useMemo(
    () => buildReferralShareMessage(referralLink),
    [referralLink]
  );

  useEffect(() => {
    setMessage(defaultMessage);
  }, [defaultMessage]);

  const share = {
    copyLink: async () => {
      if (!referralLink) {
        toast.error('Referral link is not available yet.');
        return;
      }
      await copyText(referralLink, 'Referral link copied!');
    },
    copyMessage: async () => {
      await copyText(message, 'Referral message copied!');
    },
    whatsapp: () => {
      openShareWindow(
        `https://wa.me/?text=${encodeURIComponent(message)}`
      );
    },
    telegram: () => {
      openShareWindow(
        `https://t.me/share/url?url=${encodeURIComponent(
          referralLink
        )}&text=${encodeURIComponent(message)}`
      );
    },
    linkedin: () => {
      if (!referralLink) {
        toast.error('Referral link is not available yet.');
        return;
      }
      openShareWindow(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          referralLink
        )}`
      );
    },
    facebook: () => {
      if (!referralLink) {
        toast.error('Referral link is not available yet.');
        return;
      }
      openShareWindow(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          referralLink
        )}`
      );
    },
    instagram: async () => {
      await copyText(message, 'Message copied. Paste it into Instagram.');
    },
  };

  return {
    message,
    setMessage,
    ...share,
  };
};

export default useReferralShare;
